import React, { useState } from 'react';
import { styled } from '@glitz/react';
import { Paragraph, ResponsiveLineHeight, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import { ButtonHeight, ButtonTheme, SolidButton } from 'Shared/TextButtons';
import ProductActivity from '../Models/ProductActivity.type';

type ProductActivitiesType = {
  productActivities: ProductActivity[];
};

const ButtonWrapper = styled.div({
  display: 'flex', 
  flexWrap: 'wrap', 
  gap: '8px',
})

const Text = styled(Paragraph, {
  marginTop: '24px',
})

function ProductActivities({ productActivities }: ProductActivitiesType) {
  const [selectedActivityIndex, setSelectedActivityIndex] = useState(0);

  return (
    <>
      <ButtonWrapper>
        {productActivities.map((activity, index) => (
          <SolidButton
            key={index}
            text={activity.name}
            onClick={() => {
              setSelectedActivityIndex(index);
            }}
            height={ButtonHeight.Small}
            selected={index === selectedActivityIndex}
            theme={ButtonTheme.WhiteToBlack}
            padding={{ x: 12 }}
          />
        ))}
      </ButtonWrapper>
      <Text
        fontSize={ResponsiveSize.D16_M16}
        lineHeight={ResponsiveLineHeight.D130_M130}
      >
        {productActivities[selectedActivityIndex]?.productText}
      </Text>
    </>
  );
}

export default ProductActivities;
